export const searchList = [
  {
    type: 'input',
    title: 'Дансны дугаар',
    children: {
      queryKey: 'dans_dugaar',
    },
  },
];
